import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";
import SuccessView from "../../../common/success";

export default function view() {
  const $this = this;
  const { $inputs, $timer } = this;

  $this.pollConfig = {
    onBegin() { $timer.start(); },
    onCancel() { $this.pollConfig.onComplete() },
    onSuccessful() { SuccessView && SuccessView.activate.call($this) },
    onComplete() {
      /* self.console.log({ ...$this }) */
      $timer.clear();
      $this.mpesaOverrideTimeout && clearTimeout($this.mpesaOverrideTimeout);
      $this.mpesaPollingCompleted = true;
    }
  }

  return (view = ViewFactory({
    NAME: 'MPESA_CONFIRM_VIEW',
    mutables: {
      fallbackDetails: 'FALLBACK_DETAILS',
      instruction: 'MPESA_INSTRUCTION',
      secondaryInstruction: 'MPESA_SECONDARY_INSTRUCTION',
      timerCurrent: 'CURRENT_TIME',
    },
    constants: {
      hasBackAction: false,
      get phone() { return getValueAtPath($inputs, '[phone].value') },
      get selectedNetwork() { return getValueAtPath($inputs, '[network].value') }
    }
  }).call(this));
}
